import type { DashboardTaskWithEntityReferences } from "@dune/types";
import { formatSimpleDate, formatEntityReference } from "@dune/utils";
import type { ColumnDef } from "@tanstack/react-table";
import {
	TaskDueDate,
	TaskStatusBadge,
	TaskStatusIcon,
} from "../../component/tasks";

export const dashboardTasksColumns: ColumnDef<DashboardTaskWithEntityReferences>[] =
	[
		{
			id: "statusIcon",
			header: "",
			cell: ({ row }) => (
				<div className="flex items-center justify-center">
					<TaskStatusIcon task={row.original} />
				</div>
			),
			size: 50,
			enableSorting: false,
		},
		{
			id: "entityReference",
			header: "Référence",
			cell: ({ row }) => {
				const task = row.original;
				if (!task.relatedEntities || task.relatedEntities.length === 0) {
					return <div className="text-gray-500">-</div>;
				}

				const firstEntity = task.relatedEntities[0];
				const reference = formatEntityReference(
					firstEntity.entityType,
					firstEntity.entityReference,
				);

				return <div className="font-medium text-gray-900">{reference}</div>;
			},
			size: 150,
		},
		{
			accessorKey: "title",
			header: "Titre",
			cell: ({ row }) => (
				<div className="font-medium truncate">{row.original.title}</div>
			),
			size: 300,
		},
		{
			accessorKey: "status",
			header: "Statut",
			cell: ({ row }) => <TaskStatusBadge status={row.original.status} />,
			size: 200,
		},
		{
			accessorKey: "assignee",
			header: "Assigné à",
			cell: ({ row }) => {
				const assignee = row.original.assignee;
				return assignee ? `${assignee.firstname} ${assignee.lastname}` : "-";
			},
			size: 200,
		},
		{
			accessorKey: "dueDate",
			header: "Date d'échéance",
			cell: ({ row }) => (
				<TaskDueDate task={row.original} showIcon={false} variant="full" />
			),
			size: 200,
		},
		{
			accessorKey: "createdAt",
			header: "Créé le",
			cell: ({ row }) => formatSimpleDate(row.original.createdAt),
			size: 150,
		},
	];
